/* less/lib/less/tree/paren */ function _(require, module, exports) {
    var Node = require(232) /* ./node */;
    var Paren = function (node) {
        this.value = node;
    };
    Paren.prototype = new Node();
    Paren.prototype.type = 'Paren';
    Paren.prototype.genCSS = function (context, output) {
        output.add('(');
        this.value.genCSS(context, output);
        output.add(')');
    };
    Paren.prototype.eval = function (context) {
        return new Paren(this.value.eval(context));
    };
    module.exports = Paren;
}
